import { PmsWritebackStatus } from './types/pms-writeback-status';

export interface AppointmentProcedure {
  id: number;
  tooth: string;
  code: string;
  description: string;
  abountBilled: number;
}

export interface PatientAppointment {
  id: number;
  date: string;
  description: string;
  status: AppointmentStatus;
  spend?: number;
}

export enum AppointmentStatus {
  Unconfirmed = 0,
  Confirmed = 1,
  Cancelled = 2,
  Deleted = 255
}

export const AppointmentStatusText = {
  [AppointmentStatus.Confirmed]: 'Confirmed',
  [AppointmentStatus.Unconfirmed]: 'Unconfirmed',
  [AppointmentStatus.Cancelled]: 'Cancelled',
  [AppointmentStatus.Deleted]: 'Deleted'
};

export interface AppointmentSlotItem {
  id: number;
  patientId: number;
  patientName: string;
  hasPhoneNumber: boolean;
  hasMobilePhoneNumber: boolean;
  startDate: string;
  endDate: string;
  operatoryId: number;
  operatoryName: string;
  providerId: number;
  status: AppointmentStatus;
  noShowsInThePastYear: number;
  communications: any[];
}

export type Appointment = {
  id: number;
  patientId: number;
  patientName: string;
  hasPhoneNumber: boolean;
  hasMobilePhoneNumber: boolean;
  startDate: Date;
  endDate: Date;
  operatoryId: number;
  operatoryName: string;
  providerId: number;
  providerName: string;
  status: number;
  noShowsInThePastYear: number;
};

export type AppointmentRequestStatuses = {
  id: number;
  pmsWritebackStatus?: PmsWritebackStatus;
};
